import { makeStyles } from '@material-ui/core'
export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  mainPaper: {
    width: '100%',
    flex: 1,
    padding: theme.spacing(2)
  },
  fullWidth: {
    width: '100%'
  },
  tableContainer: {
    width: '100%',
    overflowX: 'scroll',
    ...theme.scrollbarStyles
  },
  textfield: {
    width: '100%'
  },
  textRight: {
    textAlign: 'right'
  },
  row: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  control: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1)
  },
  buttonContainer: {
    textAlign: 'right',
    padding: theme.spacing(1)
  },
  buttonNewTutorial: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  },
  dialogTitle:{
    color: theme.palette.blue_300.main
  }
}))
